import { Controller } from "@hotwired/stimulus";
import { eventBus } from '$shared/lib/eventBus';

export default class extends Controller {
  static targets = ["container"];

  connect() {
    this.toggleClass = "hidden";
  }

  show(e) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const controller = this;

    controller.practiceShown = controller.practiceShown || false;

    const firstPracticePrompt = controller.containerTargets.length >= 1 ? controller.containerTargets[0] : false;

    if (controller.practiceShown) return;
    if (!firstPracticePrompt) return;

    const firstPracticePromptSeconds = +firstPracticePrompt.dataset.seconds;
    const currentVideoSeconds = e.detail.time;

    if (currentVideoSeconds >= firstPracticePromptSeconds) {
      controller.practiceShown = true;
      eventBus.emit('tab-change', {
        targetTabId: 'practice-panel'
      })
    }
  }
}
